import React, { useState } from "react";
import { Glyphicon } from "react-bootstrap";
import { Button } from "./Button";
import { v4 as uuidv4 } from "uuid";
import { DropdownOptions } from "./dropdown/Dropdown";
import { OverlayStyle, OverlayTrigger } from "./OverlayTrigger";
import { useStylesHook } from "./hooks/useStylesHook";
import { classNames } from "./utils/classNames";
export const DropdownButton = ({ label, items, direction = "left", type = "default", disabled = false, container, dataTestId, id, iconOnly, }) => {
    const [open, setOpen] = useState(false);
    const classes = useDropdownClasses();
    const labelId = uuidv4();
    const menuDirection = direction === "left" ? "bottom-start" : "bottom-end";
    const labelContent = iconOnly ? (React.createElement("span", null,
        React.createElement("span", { className: "sr-only" }, label),
        React.createElement(Glyphicon, { glyph: "option-vertical" }))) : (React.createElement(React.Fragment, null,
        label,
        " ",
        React.createElement("span", { className: classNames("glyphicon-pro glyphicon-pro-chevron-down", classes.icon) })));
    const button = (React.createElement(Button, { label: labelContent, id: id || labelId, type: type, disabled: disabled, stopPropagation: false, onClick: () => setOpen(!open), className: open ? "dropdown-open" : "" }));
    const options = items ? (React.createElement(DropdownOptions, { id: labelId, options: items })) : (React.createElement("span", null, "nothing to see here "));
    return (React.createElement(OverlayTrigger, { overlayTrigger: button, overlayContent: options, overlayStyle: OverlayStyle.Dropdown, placement: menuDirection, onOutsideClickDeactivate: () => setOpen(false), onClose: () => setOpen(false), container: container, dataTestId: dataTestId }));
};
const useDropdownClasses = () => useStylesHook({
    icon: {
        marginLeft: 2,
        fontSize: 13,
    },
});
